import React, { useEffect, useRef } from 'react'
import { useAnimations, useGLTF, useTexture } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import useGame from '../stores/useGame'
import * as THREE from 'three'

export function HetModule(props) {

    const group = useRef()
    const { nodes, materials, animations } = useGLTF('/HET_Module.glb')
    const { actions } = useAnimations(animations, group)
    const thruster = useGame((state) => state.thruster)

    const hetAO = useTexture('./textures/HET_Thruster_AO.webp')
      hetAO.flipY = false
      materials.HET_Thruster.aoMap = hetAO
      materials.HET_Thruster.aoMapIntensity = 1

    const state = useThree()
    const phase = useGame((state) => state.phase)

    const highlight = useGame((state) => state.highlight)

    const highlightMaterial = new THREE.MeshStandardMaterial({
      color: 'red',
      emissive: 'red',
      emissiveIntensity: 0.25,
    })

    useEffect(() => {
    if(state.size.width > 950)

    {
        if (highlight === 'h_ps') { state.scene.traverse(obj => { if(obj.name.includes('S_PS')) { obj.material = highlightMaterial } }) }

        if (highlight === 'h_fd') { state.scene.traverse(obj => { if(obj.name.includes('S_FD')) { obj.material = highlightMaterial } }) }

        if (highlight === 'h_pr') { state.scene.traverse(obj => { if(obj.name.includes('S_PR')) { obj.material = highlightMaterial } }) }
        
        if (highlight === 'null') 
            {
            state.scene.traverse(obj => {

                if(obj.name.includes('HET_S_PS') | obj.name.includes('HET_S_FD') | obj.name.includes('HET_S_PR'))
                {
                    obj.material = materials.HET_Thruster
                }
            })
            }
    }
    },[highlight])

    useEffect(() => {

        if (phase === 'zoomed') 
            {
                actions['HET_Animation'].loop = false
                actions['HET_Animation'].clampWhenFinished = true
                actions['HET_Animation'].timeScale = 1
                actions['HET_Animation'].repetitions = 0
                actions['HET_Animation'].paused = false
                actions['HET_Animation'].play()
            }
    
        if (phase != 'zoomed') 
            {
                actions['HET_Animation'].loop = false
                actions['HET_Animation'].clampWhenFinished = true
                actions['HET_Animation'].timeScale = -1
                actions['HET_Animation'].repetitions = 0
                actions['HET_Animation'].paused = false
                actions['HET_Animation'].play()
            }
        }, [phase, actions])

    return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="HET_Animator">
          <group name="HET_POI_C_CP" position={[0.491, -0.074, 0.034]} />
          <group name="HET_POI_C_FD1" position={[0.508, -0.065, -0.086]} />
          <group name="HET_POI_C_FI" position={[0.498, 0.017, -0.01]} />
          <group name="HET_POI_C_FM" position={[0.498, -0.01, 0.007]} />
          <group name="HET_POI_C_FP" position={[0.491, 0.02, 0.053]} />
          <group name="HET_POI_C_IV1" position={[0.484, -0.095, -0.011]} />
          <group name="HET_POI_C_PR1" position={[0.491, -0.102, -0.069]} />
          <group name="HET_POI_C_PR2" position={[0.491, -0.01, 0.052]} />
          <group name="HET_POI_C_SF1" position={[0.491, -0.078, -0.038]} />
          <group name="HET_POI_C_SS" position={[0.488, 0.09, 0.04]} />
          <group name="HET_POI_S_FD" position={[0.484, 0.087, 0.017]} />
          <group name="HET_POI_S_PR" position={[0.478, -0.05, 0.059]} />
          <group name="HET_POI_S_PS" position={[0.453, 0, -0.061]} />

          <group name="HET_POS_C_CP" position={[0.445, -0.074, 0.034]} />
          <group name="HET_POS_C_FD1" position={[0.462, -0.07, -0.103]} />
          <group name="HET_POS_C_FI" position={[0.454, 0.032, -0.01]} />
          <group name="HET_POS_C_FM" position={[0.459, -0.035, 0.008]} />
          <group name="HET_POS_C_FP" position={[0.445, 0.02, 0.053]} />
          <group name="HET_POS_C_IV1" position={[0.442, -0.07, -0.011]} />
          <group name="HET_POS_C_PR1" position={[0.451, -0.127, -0.062]} />
          <group name="HET_POS_C_PR2" position={[0.463, -0.01, 0.102]} />
          <group name="HET_POS_C_SF1" position={[0.446, -0.065, -0.022]} />
          <group name="HET_POS_C_SS" position={[0.434, 0.068, 0.039]} />
          <group name="HET_POS_S_FD" position={[0.411, 0.032, 0.03]} />
          <group name="HET_POS_S_PR" position={[0.4, -0.05, 0.056]} />
          <group name="HET_POS_S_PS" position={[0.398, -0.078, -0.063]} />

          <group name="HET_TAR_C_CP" position={[0.492, -0.087, 0.041]} />
          <group name="HET_TAR_C_FD1" position={[0.508, -0.087, -0.085]} />
          <group name="HET_TAR_C_FI" position={[0.513, 0.017, -0.007]} />
          <group name="HET_TAR_C_FM" position={[0.498, 0, 0.007]} />
          <group name="HET_TAR_C_FP" position={[0.491, 0.02, 0.053]} />
          <group name="HET_TAR_C_IV1" position={[0.484, -0.087, -0.011]} />
          <group name="HET_TAR_C_PR1" position={[0.491, -0.101, -0.059]} />
          <group name="HET_TAR_C_PR2" position={[0.491, -0.006, 0.073]} />
          <group name="HET_TAR_C_SF1" position={[0.491, -0.087, -0.038]} />
          <group name="HET_TAR_C_SS" position={[0.488, 0.076, 0.04]} />
          <group name="HET_TAR_S_FD" position={[0.491, 0.043, 0.022]} />
          <group name="HET_TAR_S_PR" position={[0.49, -0.043, 0.059]} />
          <group name="HET_TAR_S_PS" position={[0.471, -0.073, -0.054]} />

          {thruster === 'HET' | thruster === 'null' && <> 
          <mesh
            name="HET_C_Back_Plate"
            castShadow
            receiveShadow
            geometry={nodes.HET_C_Back_Plate.geometry}
            material={materials.HET_Thruster}
            position={[0.518, 0, 0]}
          />
          <mesh
            name="HET_C_Powercable"
            castShadow
            receiveShadow
            geometry={nodes.HET_C_Powercable.geometry}
            material={materials.HET_Thruster}
            position={[0.499, 0.003, 0.088]}
            rotation={[-Math.PI, 0, 0]}
            scale={0.688}
          />
          <mesh
            name="HET_S_FD_C_Box"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_FD_C_Box.geometry}
            material={materials.HET_Thruster}
            position={[0.497, 0.089, 0.039]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            name="HET_S_FD_C_FI"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_FD_C_FI.geometry}
            material={materials.HET_Thruster}
            position={[0.519, 0, 0]}
          />
          <mesh
            name="HET_S_FD_C_FM"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_FD_C_FM.geometry}
            material={materials.HET_Thruster}
            position={[0.507, 0, 0.014]}
            rotation={[0, -1.571, 0]}
          />
          <mesh
            name="HET_S_FD_C_SS_Red"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_FD_C_SS_Red.geometry}
            material={materials.HET_Thruster}
            position={[0.491, -0.009, -0.009]}
          />
          <mesh
            name="HET_S_FD_C_SS_White"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_FD_C_SS_White.geometry}
            material={materials.HET_Thruster}
            position={[0.491, -0.009, -0.009]}
          />
          <mesh
            name="HET_S_PR_C_Bottle"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PR_C_Bottle.geometry}
            material={materials.HET_Thruster}
            position={[0.493, -0.045, 0.059]}
          />
          <mesh
            name="HET_S_PR_C_CP"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PR_C_CP.geometry}
            material={materials.HET_Thruster}
            position={[0.498, -0.087, 0.041]}
          />
          <mesh
            name="HET_S_PR_C_FP"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PR_C_FP.geometry}
            material={materials.HET_Thruster}
            position={[0.498, 0.019, 0.053]}
          />
          <mesh
            name="HET_S_PR_C_Pipes"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PR_C_Pipes.geometry}
            material={materials.HET_Thruster}
            position={[0.491, -0.009, -0.009]}
          />
          <mesh
            name="HET_S_PR_C_PR2"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PR_C_PR2.geometry}
            material={materials.HET_Thruster}
            position={[0.498, -0.005, 0.073]}
          />
          <mesh
            name="HET_S_PR_C_Join_1"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PR_C_Join_1.geometry}
            material={materials.HET_Thruster}
            position={[0.491, -0.087, 0.059]}
          />
          <mesh
            name="HET_S_PR_C_Join_2"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PR_C_Join_2.geometry}
            material={materials.HET_Thruster}
            position={[0.491, -0.005, 0.059]}
          />
          <mesh
            name="HET_S_PS_C_FD1"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PS_C_FD1.geometry}
            material={materials.HET_Thruster}
            position={[0.516, -0.087, -0.085]}
          />
          <mesh
            name="HET_S_PS_C_IV1"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PS_C_IV1.geometry}
            material={materials.HET_Thruster}
            position={[0.496, -0.087, -0.011]}
          />
          <mesh
            name="HET_S_PS_C_Join"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PS_C_Join.geometry}
            material={materials.HET_Thruster}
            position={[0.491, -0.087, -0.059]}
          />
          <mesh
            name="HET_S_PS_C_Pipes"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PS_C_Pipes.geometry}
            material={materials.HET_Thruster}
            position={[0.491, -0.009, -0.009]}
          />
          <mesh
            name="HET_S_PS_C_PR1"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PS_C_PR1.geometry}
            material={materials.HET_Thruster}
            position={[0.498, -0.101, -0.059]}
          />
          <mesh
            name="HET_S_PS_C_SF1"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PS_C_SF1.geometry}
            material={materials.HET_Thruster}
            position={[0.498, -0.087, -0.038]}
          />
          <mesh
            name="HET_S_PS_C_Tank"
            castShadow
            receiveShadow
            geometry={nodes.HET_S_PS_C_Tank.geometry}
            material={materials.HET_Thruster}
            position={[0.481, 0.017, -0.059]}
          /></>}
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/HET_Module.glb')